// Enum de categorias com IDs numéricos
export const PRODUCT_CATEGORIES = {
  0: 'sofas',
  1: 'mesas',
  2: 'cadeiras',
  3: 'balancos',
  4: 'banquetes',
  5: 'espreguicadeiras',
  6: 'bancos',
  7: 'poltronas'
};

// Mapeamento reverso para obter ID pela categoria
export const CATEGORY_TO_ID = {
  'sofas': 0,
  'mesas': 1,
  'cadeiras': 2,
  'balancos': 3,
  'banquetes': 4,
  'espreguicadeiras': 5,
  'bancos': 6,
  'poltronas': 7
};

// Labels em português para exibição
export const CATEGORY_LABELS = {
  0: 'Sofás',
  1: 'Mesas',
  2: 'Cadeiras',
  3: 'Balanços',
  4: 'Banquetes',
  5: 'Espreguiçadeiras',
  6: 'Bancos',
  7: 'Poltronas'
};

// Características disponíveis para os produtos
export const PRODUCT_CHARACTERISTICS = {
  corda: 'Corda',
  cor: 'Cor',
  fibra: 'Fibra',
  madeira: 'Madeira',
  tecidoPremium: 'Tecido Premium',
  tecido: 'Tecido'
};

// Dados dos produtos com categorias por ID numérico
export const allProducts = [
  {
    id: 1,
    name: "Mesa de Jantar Artesanal Mogno",
    categoryId: 1, // mesas
    price: 2500,
    image: "/assets/image-produtos/mesas/image01.jpg",
    materials: ["madeira"],
    characteristics: {
      madeira: "Mogno",
      cor: "Marrom escuro"
    },
    description: "Mesa de jantar em madeira de mogno com acabamento artesanal"
  },
  {
    id: 2,
    name: "Conjunto de Sofá no Trico Náutico",
    categoryId: 0, // sofas
    price: 4500,
    image: "/assets/image-produtos/sofas/image01.jpeg",
    materials: ["corda"],
    characteristics: {
      corda: "Trico náutico",
      cor: "Azul escuro"
    },
    description: "Conjunto de sofá artesanal com acabamento em trico náutico, perfeito para ambientes rústicos e náuticos"
  },
  {
    id: 3,
    name: "Espreguiçadeira feita em Trico Náutico e Alumínio",
    categoryId: 5, // espreguicadeiras
    price: 1200,
    image: "/assets/image-produtos/espreguicadeiras/image01.jpeg",
    materials: ["corda", "alumínio"],
    characteristics: {
      corda: "Trico náutico",
      cor: "Natural"
    },
    description: "Espreguiçadeira confortável com acabamento em trico náutico e estrutura em alumínio, ideal para áreas externas e praia"
  },
  {
    id: 4,
    name: "Balanço em Trico Náutico e Alumínio",
    categoryId: 3, // balancos
    price: 800,
    image: "/assets/image-produtos/balancos/image01.jpeg",
    materials: ["corda", "alumínio"],
    characteristics: {
      corda: "Trico náutico",
      cor: "Natural"
    },
    description: "Balanço artesanal com acabamento em trico náutico e estrutura em alumínio, perfeito para área externa"
  },
  // Espreguiçadeiras
  {
    id: 7,
    name: "Espreguiçadeira em Formato de Folha - Trico Náutico",
    categoryId: 5, // espreguicadeiras
    price: 380,
    image: "/assets/image-produtos/espreguicadeiras/image02.jpeg",
    materials: ["corda"],
    characteristics: {
      corda: "Trico náutico",
      cor: "Natural"
    },
    description: "Espreguiçadeira em formato de folha artesanalmente trabalhada em trico náutico, perfeita para áreas externas"
  },
  {
    id: 10,
    name: "Espreguiçadeira em Fita Náutica",
    categoryId: 5, // espreguicadeiras
    price: 290,
    image: "/assets/image-produtos/espreguicadeiras/image05.jpeg",
    materials: ["corda", "alumínio"],
    characteristics: {
      corda: "Fita náutica",
      cor: "Natural"
    },
    description: "Espreguiçadeira minimalista com assento em fita náutica e base em alumínio"
  },
  {
    id: 12,
    name: "Espreguiçadeira de Jardim",
    categoryId: 5, // espreguicadeiras
    price: 350,
    image: "/assets/image-produtos/espreguicadeiras/image07.jpeg",
    materials: ["corda", "alumínio"],
    characteristics: {
      corda: "Trico náutico",
      cor: "Natural"
    },
    description: "Espreguiçadeira resistente para jardim com acabamento em trico náutico e estrutura em alumínio"
  },
  {
    id: 13,
    name: "Espreguiçadeira Artesanal",
    categoryId: 5, // espreguicadeiras
    price: 420,
    image: "/assets/image-produtos/espreguicadeiras/image08.jpeg",
    materials: ["madeira", "fibra"],
    characteristics: {
      madeira: "Maciça",
      fibra: "Natural",
      cor: "Bege"
    },
    description: "Espreguiçadeira artesanal com acabamento em fibra natural"
  },
  {
    id: 14,
    name: "Espreguiçadeira Contemporânea",
    categoryId: 5, // espreguicadeiras
    price: 480,
    image: "/assets/image-produtos/espreguicadeiras/image09.jpeg",
    materials: ["madeira", "metal"],
    characteristics: {
      madeira: "Freijó",
      cor: "Cinza"
    },
    description: "Espreguiçadeira contemporânea com estrutura metálica e madeira"
  },
  {
    id: 15,
    name: "Espreguiçadeira de Bambu",
    categoryId: 5, // espreguicadeiras
    price: 280,
    image: "/assets/image-produtos/espreguicadeiras/image10.jpeg",
    materials: ["bambu", "corda"],
    characteristics: {
      fibra: "Bambu",
      corda: "Juta",
      cor: "Natural"
    },
    description: "Espreguiçadeira ecológica em bambu com cordas de juta"
  },
  {
    id: 16,
    name: "Espreguiçadeira Premium",
    categoryId: 5, // espreguicadeiras
    price: 750,
    image: "/assets/image-produtos/espreguicadeiras/image11.jpeg",
    materials: ["madeira", "tecido premium"],
    characteristics: {
      madeira: "Certificada",
      tecidoPremium: "Alta qualidade",
      cor: "Azul"
    },
    description: "Espreguiçadeira premium com tecido de alta qualidade e madeira certificada"
  },
  {
    id: 18,
    name: "Espreguiçadeira Clássica",
    categoryId: 5, // espreguicadeiras
    price: 320,
    image: "/assets/image-produtos/espreguicadeiras/image13.jpeg",
    materials: ["madeira"],
    characteristics: {
      madeira: "Mogno",
      cor: "Marrom escuro"
    },
    description: "Espreguiçadeira clássica em madeira de mogno com design tradicional"
  },
  {
    id: 19,
    name: "Espreguiçadeira de Vime Natural",
    categoryId: 5, // espreguicadeiras
    price: 350,
    image: "/assets/image-produtos/espreguicadeiras/image14.jpeg",
    materials: ["vime", "madeira"],
    characteristics: {
      madeira: "Lei",
      fibra: "Vime natural",
      cor: "Natural"
    },
    description: "Espreguiçadeira em vime natural com estrutura de madeira de lei"
  },
  {
    id: 21,
    name: "Espreguiçadeira de Balanço Dupla",
    categoryId: 5, // espreguicadeiras
    price: 850,
    image: "/assets/image-produtos/espreguicadeiras/image16.jpeg",
    materials: ["madeira", "corda", "tecido"],
    characteristics: {
      madeira: "Robusta",
      corda: "Sisal",
      tecido: "Resistente",
      cor: "Marrom"
    },
    description: "Espreguiçadeira de balanço dupla para casais com estrutura robusta"
  },
  {
    id: 22,
    name: "Espreguiçadeira Rústica Premium",
    categoryId: 5, // espreguicadeiras
    price: 580,
    image: "/assets/image-produtos/espreguicadeiras/image17.jpeg",
    materials: ["madeira", "couro"],
    characteristics: {
      madeira: "Maciça",
      tecidoPremium: "Couro artesanal",
      cor: "Marrom claro"
    },
    description: "Espreguiçadeira rústica premium com detalhes em couro artesanal"
  },
  {
    id: 23,
    name: "Espreguiçadeira de Praia Dobrável",
    categoryId: 5, // espreguicadeiras
    price: 320,
    image: "/assets/image-produtos/espreguicadeiras/image18.jpeg",
    materials: ["madeira", "tecido"],
    characteristics: {
      madeira: "Leve",
      tecido: "Portátil",
      cor: "Azul claro"
    },
    description: "Espreguiçadeira de praia dobrável e portátil para viagens"
  },
  {
    id: 24,
    name: "Espreguiçadeira de Luxo Artesanal",
    categoryId: 5, // espreguicadeiras
    price: 920,
    image: "/assets/image-produtos/espreguicadeiras/image19.jpeg",
    materials: ["madeira", "tecido premium", "metal"],
    characteristics: {
      madeira: "Nobre",
      tecidoPremium: "Alta qualidade",
      cor: "Dourado"
    },
    description: "Espreguiçadeira de luxo artesanal com acabamentos especiais e design único"
  },
  // Balanços
  {
    id: 25,
    name: "Balanço de Madeira Artesanal",
    categoryId: 3, // balancos
    price: 650,
    image: "/assets/image-produtos/balancos/image02.jpeg",
    materials: ["madeira", "corda"],
    characteristics: {
      madeira: "Maciça",
      corda: "Sisal resistente",
      cor: "Natural"
    },
    description: "Balanço artesanal em madeira maciça com cordas de sisal resistentes"
  },
  {
    id: 26,
    name: "Balanço de Vime Premium",
    categoryId: 3, // balancos
    price: 480,
    image: "/assets/image-produtos/balancos/image02.jpeg",
    materials: ["vime", "madeira", "corda"],
    characteristics: {
      madeira: "Elegante",
      fibra: "Vime premium",
      corda: "Sisal",
      cor: "Natural"
    },
    description: "Balanço de vime premium com estrutura de madeira e design elegante"
  },
  // Mesas
  {
    id: 27,
    name: "Mesa de Centro Moderna",
    categoryId: 1, // mesas
    price: 1200,
    image: "/assets/image-produtos/mesas/image02.jpg",
    materials: ["madeira", "vidro"],
    characteristics: {
      madeira: "Nobre",
      cor: "Transparente"
    },
    description: "Mesa de centro moderna com tampo em vidro e base em madeira nobre"
  },
  {
    id: 28,
    name: "Mesa de Jantar Rústica",
    categoryId: 1, // mesas
    price: 1800,
    image: "/assets/image-produtos/mesas/image03.jpg",
    materials: ["madeira"],
    characteristics: {
      madeira: "Demolição",
      cor: "Rústica"
    },
    description: "Mesa de jantar rústica em madeira de demolição com acabamento artesanal"
  },
  {
    id: 29,
    name: "Mesa de Escritório Executiva",
    categoryId: 1, // mesas
    price: 2200,
    image: "/assets/image-produtos/mesas/image04.jpg",
    materials: ["madeira", "metal"],
    characteristics: {
      madeira: "Lei",
      cor: "Marrom escuro"
    },
    description: "Mesa de escritório executiva com gavetas e acabamento em madeira de lei"
  },
  // Poltronas
  {
    id: 31,
    name: "Poltrona de Leitura Premium",
    categoryId: 7, // poltronas
    price: 1500,
    image: "/assets/image-produtos/poltrona/image01.jpeg",
    materials: ["madeira", "couro", "tecido"],
    characteristics: {
      madeira: "Nobre",
      tecidoPremium: "Couro",
      tecido: "Estofamento",
      cor: "Marrom"
    },
    description: "Poltrona de leitura premium com apoio para pés e estofamento em couro"
  },
  // Sofás
  {
    id: 32,
    name: "Sofá Retrátil Moderno",
    categoryId: 0, // sofas
    price: 3200,
    image: "/assets/image-produtos/sofas/image02.jpeg",
    materials: ["madeira", "tecido"],
    characteristics: {
      madeira: "Maciça",
      tecido: "Confortável",
      cor: "Cinza"
    },
    description: "Sofá retrátil moderno com estrutura em madeira e estofamento confortável"
  },
  {
    id: 33,
    name: "Sofá de Canto Premium",
    categoryId: 0, // sofas
    price: 4500,
    image: "/assets/image-produtos/sofas/image03.jpeg",
    materials: ["madeira", "couro"],
    characteristics: {
      madeira: "Maciça",
      tecidoPremium: "Couro premium",
      cor: "Marrom"
    },
    description: "Sofá de canto premium em couro com estrutura de madeira maciça"
  },
  {
    id: 34,
    name: "Sofá 3 Lugares Clássico",
    categoryId: 0, // sofas
    price: 2800,
    image: "/assets/image-produtos/sofas/image04.jpeg",
    materials: ["madeira", "tecido"],
    characteristics: {
      madeira: "Maciça",
      tecido: "Premium",
      cor: "Azul"
    },
    description: "Sofá 3 lugares clássico com design atemporal e conforto excepcional"
  },
  {
    id: 35,
    name: "Sofá Modular Contemporâneo",
    categoryId: 0, // sofas
    price: 3800,
    image: "/assets/image-produtos/sofas/image05.jpeg",
    materials: ["madeira", "tecido premium"],
    characteristics: {
      madeira: "Nobre",
      tecidoPremium: "Alta qualidade",
      cor: "Cinza"
    },
    description: "Sofá modular contemporâneo com possibilidade de configuração personalizada"
  },
  {
    id: 36,
    name: "Sofá de Dois Lugares Elegante",
    categoryId: 0, // sofas
    price: 2200,
    image: "/assets/image-produtos/sofas/image06.jpeg",
    materials: ["madeira", "tecido"],
    characteristics: {
      madeira: "Qualidade",
      tecido: "Elegante",
      cor: "Bege"
    },
    description: "Sofá de dois lugares elegante com design clean e materiais de qualidade"
  },
  {
    id: 37,
    name: "Sofá Chesterfield Luxo",
    categoryId: 0, // sofas
    price: 5200,
    image: "/assets/image-produtos/sofas/image07.jpeg",
    materials: ["madeira", "couro premium"],
    characteristics: {
      madeira: "Nobre",
      tecidoPremium: "Couro premium",
      cor: "Marrom escuro"
    },
    description: "Sofá Chesterfield de luxo em couro premium com acabamento artesanal"
  },
  {
    id: 38,
    name: "Sofá de Canto Rústico",
    categoryId: 0, // sofas
    price: 3500,
    image: "/assets/image-produtos/sofas/image08.jpeg",
    materials: ["madeira", "tecido rústico"],
    characteristics: {
      madeira: "Natural",
      tecido: "Rústico",
      cor: "Marrom claro"
    },
    description: "Sofá de canto rústico com design campestre e materiais naturais"
  },
  {
    id: 40,
    name: "Sofá de Luxo Artesanal",
    categoryId: 0, // sofas
    price: 6800,
    image: "/assets/image-produtos/sofas/image09.jpg",
    materials: ["madeira", "couro", "metal"],
    characteristics: {
      madeira: "Nobre",
      tecidoPremium: "Couro artesanal",
      cor: "Dourado"
    },
    description: "Sofá de luxo artesanal com detalhes especiais e acabamento premium"
  }
];
